import type { CartPackageImageNodeDisplayModel } from '@shared/models/carts/cartPackageImageNodes';
import type { Cartv2PackageDisplayModel, Cartv2PackageItemDisplayModel } from '@shared/models/carts/cartPackages';
import type { CartPackageTextNodeDisplayModel } from '@shared/models/carts/cartPackageTextNotes';
import type { PackageItemDisplayModel } from '@shared/models/packages/packageItems';
import type {
  PackageItemImageNodeDisplayModel,
  PackageItemTextNodeDisplayModel,
} from '@shared/models/packages/packageNodes';
import type { IPackageModelProperties, PackageDisplayModel } from '@shared/models/packages/packages';
import type { SubjectImageDisplayModel } from '@shared/models/subjects/images';
import type { SubjectFieldCreateModel, SubjectFieldDisplayModel } from '@shared/models/subjects/subjectFields';
import type { SubjectDisplayModel } from '@shared/models/subjects/subjects';
import {
  isIndividualImageNode,
  isValidImageNode,
  isAutoFilledIndividualImageNode,
} from '@shared/services/packageNodes.service';
import type { EntrySubjectModel } from '@shared/models/entry/entry';
import { fillAutoFilledTextNode, fillTextNode } from './cartPackageNode.service';

//TODO: mapTextNode and mapImageNode are setting the cartpackage node id to the package node id. This is not correct. This is a bug.

export const mapTextNode = (
  node: PackageItemTextNodeDisplayModel,
  // packageItemId: number,
): CartPackageTextNodeDisplayModel => ({
  ...node,
  packageItemTextNodeId: node.id,
  //   cartPackageId: null,
  value: '',
  // packageItemId,
});

export const mapImageNode = (
  node: PackageItemImageNodeDisplayModel,
  // packageItemId: number,
): CartPackageImageNodeDisplayModel => ({
  ...node,
  packageItemImageNodeId: node.id,
  groupImageId: null,
  subjectImageId: null,
  replacementImageId: null,
  frontendCropDimensions: null,
  cropDimensions: null,
  //   cartPackageId: null,
  imageThumbnailUrl: '',
  //   cropDimensions: '',
  // imageNodeData: node,
  // packageItemId,
});
export const mapCartPackageItem = (item: PackageItemDisplayModel): Cartv2PackageItemDisplayModel => ({
  ...item,
  id: item.id,
  // packageItemId: item.id,
  displayName: item.altName || item.name,
  imageNodes: item.imageNodes.filter((i) => !i.static && isValidImageNode(i)).map((n) => mapImageNode(n)), // , item.id)),
  textNodes: item.textNodes.filter((t) => t.editable).map((n) => mapTextNode(n)), // , item.id)))
});

export const applySubjectImageToCartPackageItem = (
  img: SubjectImageDisplayModel,
  item: Cartv2PackageItemDisplayModel,
): Cartv2PackageItemDisplayModel => ({
  ...item,
  imageNodes: item.imageNodes.map((i) => ({
    ...i,
    subjectImageId: isAutoFilledIndividualImageNode(i) ? img.id : null,
    groupImageId: null,
    // cropDimensions: null,
    imageThumbnailUrl: isAutoFilledIndividualImageNode(i) ? img.imageThumbnailUrl : null,
  })),
});

export const fillPackageTextNodes = (
  fields: (SubjectFieldDisplayModel | SubjectFieldCreateModel)[],
  item: Cartv2PackageItemDisplayModel,
): Cartv2PackageItemDisplayModel => ({
  ...item,
  textNodes: item.textNodes.map((node) => ({
    ...node,
    ...fillTextNode(node, fields),
  })),
});

export const getCartPackageFromPackageAndImage = (
  pkg: PackageDisplayModel,
  subject: SubjectDisplayModel | EntrySubjectModel,
  img?: SubjectImageDisplayModel,
): Cartv2PackageDisplayModel => {
  const model: Cartv2PackageDisplayModel = {
    ...(pkg as IPackageModelProperties),
    packageId: pkg.id,
    quantity: 1,
    price: pkg.retailCost,
    subjectName: `${subject.firstName} ${subject.lastName}`,
    subjectLastName: subject.lastName ?? '',
    subjectFirstName: subject.firstName ?? '',
    subjectId: subject.id,
    jobId: subject.jobId!,
    description: pkg.altDescription || 'Prints for package',
    //TODO: added to build
    taxableProductClass: '',
    code: '',
    greenScreen: undefined,
    packageName: pkg.name,
    cartPackageItems: pkg.items.map((i) => fillPackageTextNodes(subject.fields ?? [], mapCartPackageItem(i))),
  };
  if (img) {
    model.cartPackageItems = model.cartPackageItems.map((i) => applySubjectImageToCartPackageItem(img, i));
  }
  return model;
};

export const fillAutoFiledPackageTextNodes = (
  fields: SubjectFieldDisplayModel[],
  item: Cartv2PackageItemDisplayModel,
  hasImportedData: boolean,
): Cartv2PackageItemDisplayModel => ({
  ...item,
  textNodes: item.textNodes.map((node) => ({
    ...node,
    ...fillAutoFilledTextNode(node, fields, hasImportedData),
  })),
});

export const getCartPackageFromServer = (
  pkg: Cartv2PackageDisplayModel,
  subject: SubjectDisplayModel,
  hasImportedData: boolean,
): Cartv2PackageDisplayModel => {
  return {
    ...pkg,
    cartPackageItems: pkg.cartPackageItems.map((i) =>
      fillAutoFiledPackageTextNodes(subject.fields, i, hasImportedData),
    ),
  };
};
